export default {
    namespaced: true,
    state: {
      autoChangeEndDate: false,
      payload: {
        start_date: '',
        end_date: '',
        measures: [],
        rows_per_page: 10,
        page_nr: 1,
        sort_by: '',
        sort_direction: 'ASC',
        reachCriteria: 5,
        columns: [],
        title_search: '',
        site_id: [],
        queryKeys: [],
      },
    },
    getters: {
      reachApiBody: state => state.payload,
    },
    mutations: {
      updateMeasures(state, newMeasures) {
        state.payload.measures = newMeasures;
      },
      updateQueryKeys(state, newQueryKeys) {
        state.payload.queryKeys = newQueryKeys;
      },
      emptyQueryKeys(state) {
        state.payload.queryKeys = [];
      },
      updateStartDate(state, newStartDate) {
        state.payload.start_date = newStartDate;
      },
      updateEndDate(state, newEndDate) {
        state.payload.end_date = newEndDate;
      },
      updateMeasureType(state, newMeasureType) {
        state.payload.measures.forEach(measure => {
          measure.measure_type = newMeasureType;
        });
      },
      updateMinViewingTime(state, newMinViewingTime) {
        state.payload.reachCriteria = newMinViewingTime;
        state.payload.measures.forEach(measure => {
          measure.min_viewing_time = newMinViewingTime;
        });
      },
      updateAutoChangeEndDate(state, newAutoChangeEndDate) {
        state.autoChangeEndDate = newAutoChangeEndDate;
      },
      updateSiteIds(state, newSiteIds) {
        state.payload.site_id = newSiteIds;
      }
    },
  };
  